const RETELL_API_BASE = "https://api.retellai.com";

interface RetellRequestBody {
  agent_id: string;
}

function validateRetellApiKey(apiKey: string | undefined): string {
  if (!apiKey) {
    throw new Error("RETELL_API_KEY is missing from environment variables");
  }

  if (!/^key_[a-zA-Z0-9]+$/.test(apiKey)) {
    throw new Error('Invalid RETELL_API_KEY format');
  }

  return apiKey;
}

function validateRequestBody(body: RetellRequestBody): void {
  if (!body.agent_id) {
    throw new Error("Missing required field: agent_id");
  }
}

export async function startRetellCall() {
  try {
    const apiKey = validateRetellApiKey(process.env.REACT_APP_RETELL_API_KEY);

    const requestBody: RetellRequestBody = {
      agent_id: "agent_bd88b880cd89ac9d69ed78f7ab"
    };

    validateRequestBody(requestBody);

    const response = await fetch(`${RETELL_API_BASE}/v2/create-web-call`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiKey}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.details || errorData.error || response.statusText);
    }

    const data = await response.json();

    if (!data.call_id || !data.access_token) {
      throw new Error("Invalid response from Retell API");
    }

    return {
      callId: data.call_id,
      accessToken: data.access_token,
      wsUrl: data.wsUrl || `wss://api.retellai.com/v2/websocket/${data.call_id}`,
    };

  } catch (error: any) {
    console.error("Error starting Retell call:", error);
    throw new Error(`Failed to start call: ${error.message}`);
  }
} 